import { Page, PageHero } from "../components/Layout";
import { CategoriesSection, ServicesCta, ServicesList } from "../components/services/ServicesSections";

export default function Services() {
  return (
    <Page testId="services-page">
      <PageHero image="/assets/bg-services.jpg" eyebrow="Our Services" title={<>Complete workforce solutions, <span className="text-[#D4AF37]">all under one roof.</span></>} sub="Talent acquisition, staff augmentation, HR and payroll management, visa processing, MEA documentation, immigration support, and in-house ticketing." />
      <ServicesList />
      <CategoriesSection />
      <ServicesCta />
    </Page>
  );
}